/* eslint-disable class-methods-use-this */
import Image from 'image-js';

import { updateDicomDataImage } from 'app/utils/dicom/DicomData';
import makeDicomFromAcquisitionDetails from 'app/utils/dicom/makeDicomFromAcquisitionDetails';
import { ImageLoader } from 'app/interfaces/ImageLoader';
import { IntlShape } from 'react-intl';
import { AcquisitionDetails, StoredImage, StudyStore } from 'app/interfaces/StudyStore';
import { LocalDicomStore } from 'app/interfaces/LocalDicomStore';
import { DataImage } from 'app/interfaces/DataImage';
import { DicomData } from 'app/interfaces/Dicom';

export default class LocalStudyStore {
  private localDicomStore: LocalDicomStore;
  private intl: IntlShape;
  private clinicInfo: Record<string, any> | null = null;

  constructor() {
    this.localDicomStore = undefined;
    this.intl = undefined;
  }

  syncLocalDicomStore(localDicomStore: LocalDicomStore) {
    this.localDicomStore = localDicomStore;
  }

  syncIntl(intl: IntlShape) {
    this.intl = intl;
  }

  syncClinicInfo(clinicInfo) {
    this.clinicInfo = clinicInfo;
  }

  // NOOP until offline storage
  // updatePatient = async () => Promise.reject(new Error('Not implemented'));

  // deleteImage = async () => Promise.reject(new Error('Not implemented'));

  // getStudy = async () => Promise.reject(new Error('Not implemented'));

  // updateReport = async () => Promise.reject(new Error('Not implemented'));

  // updateImage = async () => Promise.reject(new Error('Not implemented'));

  // updateThumbnailImage = async () => Promise.reject(new Error('Not implemented'));

  loadImage: StudyStore['loadImage'] = (studyId: string, imageId: string): Promise<StoredImage> => {
    return this.localDicomStore?.getStoredImage(studyId, imageId);
  };

  loadThumbnail: StudyStore['loadThumbnail'] = async () =>
    Promise.reject(new Error('Not implemented'));

  saveRawImage: StudyStore['saveRawImage'] = async (
    studyId: string,
    imageId: string,
    dataImage: DataImage,
    acquisitionDetails: AcquisitionDetails,
    dicomData: DicomData
  ) => {
    try {
      let savedDicomData = makeDicomFromAcquisitionDetails({
        studyId,
        imageId,
        dicomData,
        intl: this.intl,
        clinicInfo: this.clinicInfo,
        ...acquisitionDetails,
      });
      savedDicomData = updateDicomDataImage(savedDicomData, dataImage);

      return this.localDicomStore?.storeDicomImage(studyId, imageId, savedDicomData);
    } catch (e) {
      console.error('Failed to store dicom image', e);
      throw e;
    }
  };

  saveLastProcessedImage: StudyStore['saveLastProcessedImage'] = async (
    studyId: string,
    imageId: string,
    lastProcessedImage: DataImage
  ) => {
    console.time(`${studyId}-${imageId} processedImageWrite`);
    await this.localDicomStore?.storeProcessedImage(studyId, imageId, lastProcessedImage);
    console.timeEnd(`${studyId}-${imageId} processedImageWrite`);
  };
}
